module.exports = __webpack_public_path__ + "img/property-panel.1428873e.png";